import { gql } from "@apollo/client";

import { propertyValueFragment } from "src/graphql/anti-fraud/fragments/PropertyValueFragment";
import { ruleFragment } from "src/graphql/anti-fraud/fragments/RuleFragment";

export const ruleExecutionDetailsFragment = gql`
  fragment RuleExecutionDetailsFragment on RuleExecutionResult {
    id
    ruleScore
    cases {
      id
      typeCode
      properties {
        ...PropertyValueFragment
      }
    }
    rule {
      ...RuleFragment
    }
  }

  ${propertyValueFragment}
  ${ruleFragment}
`;
